
import { computed, defineComponent, ref } from 'vue';
import ConfirmPasswordModal from '@/components/modals/ConfirmPasswordModal.vue';
import SettingsLayout from '@/components/layouts/SettingsLayout.vue';
import Toggle from '@/components/ui-elements/form/Toggle.vue';
import useHttp from '@/hooks/useHttp';
import { useUserStore } from '@/store';

export default defineComponent({
	components: {
		ConfirmPasswordModal,
		SettingsLayout,
		Toggle,
	},
	setup() {
		const { postAuth, getAuth, deleteAuth } = useHttp();
		const userStore = useUserStore();
		const qrCode = ref('');
		const recoveryCodes = ref<string[]>([]);
		const showConfirmPasswordModal = ref(false);
		const toggleState = computed(() => userStore.user.mfa_enabled);

		const disableTwoFactor = async () => {
			const { error, success } = await deleteAuth({
				path: '/user/two-factor-authentication',
			});

			if (success) {
				qrCode.value = '';
				recoveryCodes.value = [];
				userStore.setMfa(false);
			}

			if (!success && error === 'Password confirmation required.') {
				showConfirmPasswordModal.value = true;
			}
		};

		const getQRCode = async () => {
			const { success, data } = await getAuth({
				path: '/user/two-factor-qr-code',
			});

			if (success) {
				qrCode.value = data?.svg;
			}
		};

		const getRecoveryCodes = async () => {
			const { success, data } = await getAuth({
				path: '/user/two-factor-recovery-codes',
			});

			if (success) {
				recoveryCodes.value = data;
			}
		};

		const enableTwoFactor = async () => {
			const { success, error } = await postAuth({
				path: '/user/two-factor-authentication',
			});

			if (success) {
				userStore.setMfa(true);
				getQRCode();
				getRecoveryCodes();
			}

			if (!success && error === 'Password confirmation required.') {
				showConfirmPasswordModal.value = true;
			}
		};

		const handleToggleClick = (e: boolean) => {
			if (e) {
				enableTwoFactor();
			} else {
				disableTwoFactor();
			}
		};

		return {
			showConfirmPasswordModal,
			handleToggleClick,
			qrCode,
			recoveryCodes,
			toggleState,
		};
	},
});
